/* eslint-disable jsx-a11y/media-has-caption */
import { CloseCircleOutlined } from "@ant-design/icons";
import { Dropdown, Popover } from "antd";
import React, { useEffect, useRef, useState } from "react";
import PauseIconBlue from "../../../icons/js/PauseIconBlue";
import PlayIconJSX from "../../../icons/js/PlayIcon";
import SpeakerMuted from "../../../icons/js/SpeakerMuted";
import SpeakerUnmuted from "../../../icons/js/SpeakerUnmuted";
import { formatSecondsToHHMMSS } from "../../../library/helpers";

const AudioPlayer = ({ src, showClose, onClose }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef();
  const [speed, setSpeed] = useState(1);
  const [volume, setVolume] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const togglePlay = () => {
    setIsPlaying(!isPlaying);
    const audio = audioRef?.current;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
  };

  const handleSpeedChange = e => {
    const newSpeed = parseFloat(e);
    setSpeed(newSpeed);
    const audio = audioRef?.current;
    audio.playbackRate = newSpeed;
  };
  const handleVolume = value => {
    const newVolume = parseFloat(value);
    setVolume(newVolume);
    const audio = audioRef?.current;
    audio.volume = newVolume;
  };
  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.addEventListener("timeupdate", () => {
        setCurrentTime(audio.currentTime);
      });
      audio.addEventListener("loadedmetadata", () => {
        console.log(audio.duration);
        setDuration(audio.duration);
      });
      setIsPlaying(!audio.paused);
      return () => {
        audio.removeEventListener("timeupdate", () => {
          setCurrentTime(audio.currentTime);
        });
        audio.removeEventListener("loadedmetadata", () => {
          setDuration(audio.duration);
        });
      };
    }
  }, []);
  console.log(duration === Infinity);
  useEffect(() => {
    if (currentTime === duration) {
      setIsPlaying(false);
      setCurrentTime(0);
    }
  }, [duration, currentTime]);
  const handleSeek = e => {
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = parseFloat(e.target.value);
      setCurrentTime(audio.currentTime);
    }
  };
  const speedArray = [
    { label: "0.5x", key: 0.5 },
    { label: "0.75x", key: 0.75 },
    { label: "1x", key: 1 },
    { label: "1.25x", key: 1.25 },
    { label: "1.5x", key: 1.5 },
    { label: "2x", key: 2 },
  ];

  return (
    <div
      contentEditable={false}
      className="flex-row-centered w-full gap-2 bg-gray-100 py-1.5 pr-3 pl-2 mt-2 rounded"
    >
      {audioRef?.current && !audioRef?.current?.paused ? (
        <PauseIconBlue className="cursor-pointer" onClick={togglePlay} />
      ) : (
        <PlayIconJSX className="cursor-pointer" onClick={togglePlay} />
      )}
      <audio id="audio" ref={audioRef} src={src} />
      <input
        type="range"
        className="h-[1px] w-[80%]"
        min="0"
        max={duration === Infinity ? currentTime : duration}
        step={0.000001}
        value={currentTime}
        onChange={handleSeek}
      />
      <span className="xs-400 text-gray-500">{`${formatSecondsToHHMMSS(currentTime)} / ${
        duration === Infinity ? 0 : formatSecondsToHHMMSS(duration === Infinity ? null : duration)
      }`}</span>
      <Popover
        trigger="hover"
        content={
          <input
            type="range"
            min={0}
            max={1}
            step={0.0001}
            value={volume}
            className="h-[1px]"
            onChange={e => handleVolume(e.target.value)}
          />
        }
      >
        {volume === 0 ? (
          <SpeakerMuted
            onClick={() =>
              setVolume(prev => {
                if (prev === 0) return 1;
                return 0;
              })
            }
            className="cursor-pointer"
          />
        ) : (
          <SpeakerUnmuted
            onClick={() =>
              setVolume(prev => {
                if (prev === 0) return 1;
                return 0;
              })
            }
            className="cursor-pointer"
          />
        )}
      </Popover>
      <Dropdown menu={{ items: speedArray, onClick: e => handleSpeedChange(e.key) }}>
        <span className="cursor-pointer text-grey-500">{speed}x</span>
      </Dropdown>
      {showClose && (
        <CloseCircleOutlined onClick={onClose} className="cursor-pointer text-grey-500" />
      )}
    </div>
  );
};

export default AudioPlayer;
